/**
 * 逻辑流编辑器 - 策略全局配置面板
 */

import React from 'react';
import {Divider, Input, Select, Switch, Typography} from 'antd';
import type {StrategyConfig} from '../../../types/logicFlow';

const {Text} = Typography;

const TIMEFRAME_OPTIONS = [
    {value: '1m', label: '1m'},
    {value: '5m', label: '5m'},
    {value: '15m', label: '15m'},
    {value: '30m', label: '30m'},
    {value: '1h', label: '1h'},
    {value: '4h', label: '4h'},
    {value: '1d', label: '1d'},
    {value: '1w', label: '1w'},
];

interface Props {
    config: StrategyConfig;
    onUpdate: (partial: Partial<StrategyConfig>) => void;
    strategyName: string;
    title: string;
    description: string;
    onUpdateMeta: (meta: { strategyName?: string; title?: string; description?: string }) => void;
}

const StrategyConfigPanel: React.FC<Props> = ({
                                                  config,
                                                  onUpdate,
                                                  strategyName,
                                                  title,
                                                  description,
                                                  onUpdateMeta,
                                              }) => {
    return (
        <div style={containerStyle}>
            <Text strong style={{color: 'var(--pt-text-primary)', fontSize: '14px'}}>策略配置</Text>

            <div style={fieldStyle}>
                <Text type="secondary" style={{fontSize: '12px'}}>策略名称</Text>
                <Input
                    size="small"
                    value={title}
                    onChange={e => onUpdateMeta({title: e.target.value})}
                    placeholder="策略名称"
                    style={solidInputStyle}
                />
            </div>

            <div style={fieldStyle}>
                <Text type="secondary" style={{fontSize: '12px'}}>类名</Text>
                <Input
                    size="small"
                    value={strategyName}
                    onChange={e => onUpdateMeta({strategyName: e.target.value})}
                    placeholder="StrategyClassName"
                    style={solidInputStyle}
                />
            </div>

            <div style={fieldStyle}>
                <Text type="secondary" style={{fontSize: '12px'}}>描述</Text>
                <Input.TextArea
                    size="small"
                    rows={2}
                    value={description}
                    onChange={e => onUpdateMeta({description: e.target.value})}
                    placeholder="策略描述"
                    style={solidInputStyle}
                />
            </div>

            <Divider style={{margin: '8px 0', borderColor: 'rgba(255,255,255,0.08)'}}/>

            <div style={fieldStyle}>
                <Text type="secondary" style={{fontSize: '12px'}}>时间周期</Text>
                <Select
                    size="small"
                    style={{width: '100%', ...solidInputStyle}}
                    value={config.timeframe}
                    onChange={v => onUpdate({timeframe: v})}
                    options={TIMEFRAME_OPTIONS}
                />
            </div>

            <div style={fieldStyle}>
                <Text type="secondary" style={{fontSize: '12px'}}>止损比例</Text>
                <Input
                    size="small"
                    value={config.stoploss}
                    onChange={e => onUpdate({stoploss: e.target.value})}
                    placeholder="-0.10"
                    style={solidInputStyle}
                />
            </div>

            <div style={fieldStyle}>
                <Text type="secondary" style={{fontSize: '12px'}}>允许做空</Text>
                <Switch
                    size="small"
                    checked={config.canShort}
                    onChange={v => onUpdate({canShort: v})}
                />
            </div>

            <div style={fieldStyle}>
                <Text type="secondary" style={{fontSize: '12px'}}>最小收益率 (JSON)</Text>
                <Input.TextArea
                    size="small"
                    rows={3}
                    value={JSON.stringify(config.minimalRoi, null, 2)}
                    style={solidInputStyle}
                    onChange={e => {
                        try {
                            const roi = JSON.parse(e.target.value);
                            onUpdate({minimalRoi: roi});
                        } catch {
                            // 忽略
                        }
                    }}
                />
            </div>
        </div>
    );
};

const solidInputStyle: React.CSSProperties = {
    background: 'rgba(26,34,54,0.6)',
    borderColor: 'var(--pt-border)',
};

const containerStyle: React.CSSProperties = {
    padding: '14px',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
};

const fieldStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
};

export default StrategyConfigPanel;
